/*
 * @Author: Wang Bingjing
 * @Date: 2021-03-01 17:34:26
 * @LastEditTime: 2021-05-24 10:36:30
 * @LastEditors: zhengfan
 */
import React, { createContext, useReducer } from 'react';
import { getToken } from '../common/session'
import moment from 'moment'

export const SerachPropsContext = createContext({})

export const SET_SEARCH_PROPS = 'SET_SEARCH_PROPS';

const initState = {
    start_time: moment().subtract(6 + moment().day(), 'days').hours(0).startOf('hour'),
    end_time: moment().hours(23).endOf('hour'),
    token:getToken(),
    size: 10,
    page: 1,
    only_filling: false,
    only_solved:false,
}

const reducer = (state = initState, action) => {
    switch (action.type) {
        case SET_SEARCH_PROPS:
            const newState = { ...action.payload }
            return newState
        default:
            return state
    }
}

export const SerachPropsProvider = props => {
        const propsInfo = props.children.props.location.query?.propsInfo
        const [serachPropsInfo, dispatch] = useReducer(reducer , propsInfo || initState)
        return (
            <SerachPropsContext.Provider value={{ serachPropsInfo , dispatch}}>
                {props.children}
            </SerachPropsContext.Provider>
        )
}


